import { navigateTo } from '#imports'
import { computed } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { isBrowser } from '@backmarket/utils/env/isBrowser'

import { useSaveBouyguesAddress } from '~/scopes/checkout/composables/useSaveBouyguesAddress'
import { CHECKOUT } from '~/scopes/checkout/routes-names'

export function useRedirectIfAddressNeedsBouyguesNormalization() {
  const logger = useLogger()
  const { saveBouyguesAddress } = useSaveBouyguesAddress()
  const experiments = useExperiments()

  const isSinglePageAddressesEnabled = computed(() => {
    return experiments['experiment.checkoutOnePageAddress'] === 'onePageAddress'
  })

  const redirectIfAddressNeedsBouyguesNormalization = async (
    addressList: ApiSpecs['/bm/cart']['GET']['response']['addressList'],
  ) => {
    const redirectRoute = isSinglePageAddressesEnabled.value
      ? CHECKOUT.ADDRESSES
      : CHECKOUT.SHIPPING_ADDRESS

    if (!addressList.deliver || !addressList.bill) {
      logger.info(
        '[CHECKOUT] [BOUYGUES] Address list is missing deliver or bill address.',
        {
          owners: ['bot-squad-checkout-front', 'bot-squad-b2cservices-front'],
        },
      )

      await navigateTo({ name: redirectRoute })

      return
    }

    if (isBrowser()) {
      try {
        await Promise.all([
          saveBouyguesAddress(addressList.deliver, 'SHIPPING'),
          saveBouyguesAddress(addressList.bill, 'BILLING'),
        ])
      } catch {
        logger.info(
          '[CHECKOUT] [BOUYGUES] User shipping address needs normalization. Redirecting to shipping address step.',
          {
            owners: ['bot-squad-checkout-front', 'bot-squad-b2cservices-front'],
          },
        )

        await navigateTo({ name: redirectRoute })
      }
    }
  }

  return { redirectIfAddressNeedsBouyguesNormalization }
}
